import type { Zone } from '@seek/audience-zones';
import type { Brand, Country, Language } from '@seek/melways-sites';
import { createStore, applyMiddleware } from 'redux';

import middlewares from './middlewares';
import type { ApiInterface } from './modules/api';
import reducers from './reducers';

export default (
  siteCountry: Country,
  brand: Brand,
  language: Language,
  zone: Zone,
  api: ApiInterface,
) => {
  const middlewareList = middlewares(siteCountry, brand, language, zone, api);

  const createStoreWithMiddleware = applyMiddleware(...middlewareList)(
    createStore,
  );

  return createStoreWithMiddleware(
    reducers,
    typeof window !== 'undefined' &&
      window.__REDUX_DEVTOOLS_EXTENSION__ &&
      window.__REDUX_DEVTOOLS_EXTENSION__(),
  );
};
